import { Injectable } from "@angular/core";
import { Layouts } from "./se.layouts";
import {
    DataAccess,
    HttpDeleteRequestOptions,
    HttpGetRequestOptions,
    HttpPutRequestOptions,
} from "../../../dataaccess/data.access";
import { Proto } from "../../../pojo/Proto";
import NumericalString = Proto.NumericalString;
import { S25Util } from "../../../util/s25-util";

@Injectable({ providedIn: "platform" })
export class SeLayoutsService {
    async getLayouts(httpOptions?: HttpGetRequestOptions): Promise<Layouts.LayoutListItem[]> {
        return DataAccess.get<Layouts.LayoutListItem[]>(`/layouts/list.json`, httpOptions);
    }

    async getLayout(layoutId: number, httpOptions?: HttpGetRequestOptions): Promise<Layouts.Layout> {
        const url = `/layouts/layout.json?${DataAccess.params({ id: layoutId })}`;
        const layout = await DataAccess.get<Layouts.DBLayout>(url, httpOptions);
        return fromDBLayout(layout);
    }

    async deleteLayout(layoutId: number, httpOptions?: HttpDeleteRequestOptions): Promise<void> {
        const url = `/layouts/layout.json?${DataAccess.params({ id: layoutId })}`;
        await DataAccess.delete<Layouts.Layout>(url, httpOptions);
    }

    async updateLayout(layout: Layouts.Layout, httpOptions?: HttpPutRequestOptions): Promise<number> {
        const payload = toDBLayout(layout);
        const resp = await DataAccess.put<{ message: NumericalString }>(`/layouts/layout.json`, payload, httpOptions);
        return Number(resp.message);
    }
}

function fromDBLayout(layout: Layouts.DBLayout): Layouts.Layout {
    return {
        ...layout,
        sections: layout.sections
            .sort((a, b) => a.order! - b.order!)
            .map((section) => ({
                ...section,
                widgets: section.widgets
                    .sort((a, b) => a.order! - b.order!)
                    .map((widget) => ({
                        ...widget,
                        settings: S25Util.fromEntries(
                            widget.settings.map((setting) => [setting.id, { ...setting, value: setting.value ?? "" }]),
                        ),
                    })),
            })),
    };
}

function toDBLayout(layout: Layouts.Layout): Layouts.DBLayout {
    return {
        ...layout,
        sections: layout.sections.map((section, s) => ({
            ...section,
            order: s,
            widgets: section.widgets.map((widget, w) => ({
                ...widget,
                order: w,
                settings: Object.values(widget.settings),
            })),
        })),
    };
}
